import { messages as portugueseMessages } from './br';
import { messages as portugalMessages } from './pt';
import { messages as englishMessages } from './en';

const messages = {
  ...portugueseMessages,
  ...portugalMessages,
  ...englishMessages,
};

export { messages };
